import { api } from '../api';
import { Institution } from '../../entities/Institution';

/**
 * `PUT /institutions/{id}` (tarefa 0.13). **Campo ausente não é alterado** no back,
 * então mandar só o que mudou é suportado — esta tela manda o formulário inteiro,
 * que é o caso simples da mesma regra.
 *
 * Escopo `edit_institution`, chave nova que hoje existe só no `administrator`.
 */
export const updateInstitution = async (
  id: string,
  institutionRequest: Institution,
): Promise<Institution> => {
  const { data } = await api.put<Institution>(
    `/institutions/${id}`,
    institutionRequest,
  );

  return data;
};
